import {FormattedMessage} from "react-intl";
import React from "react";

const convertStatus = (status) => {
  switch (status) {
    case "ACCEPTED":
    case "PAY_WAIT":
      return {title: <FormattedMessage id="status-accepted" />, color: '', disabled: 'disabled'}
      break;

    case "PAID":
    case "PROCESS":
    case "CHANGED":
    case "NOT_FOUND":
    case "IN_QUEUE":
      return {title: <FormattedMessage id="status-process" />, color: ''}
      break;

    case "ABORTED":
    case "FAILED":
    case "CANCELED":
    case "REFUNDED":
      return {title: <FormattedMessage id="status-refunded" />, color: 'error'}
      break;

    case "PAY_ERROR":
      return {title: <FormattedMessage id="status-pay-error" />, color: 'error'}
      break;

    case "DONE":
      return {title: <FormattedMessage id="status-done" />, color: 'success'}
      break;
  }
}

export default convertStatus
